import { Breadcrumbs } from "../../Home/Breadcrumb"
import { BuscarEmpresaGestora } from "./Buscar";
import TableEmpresaGestora from "./Table";
import { ToastContainer } from "react-toastify";



export const EmpresasGestoras = () => {


    return (
        <>
            <ToastContainer />

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <Breadcrumbs
                            title={'Empresas Gestoras'}
                            nameFirst={'Configuración'}
                            urlFirst={'/'}
                        />

                        <BuscarEmpresaGestora />
                        <TableEmpresaGestora />


                    </div>
                </div >
            </div >
        </>
    )
}
